<div class="logout-container">
  <div class="logout-icon">
    <mat-icon class="material-symbols-rounded outline">emergency_home</mat-icon>
  </div>
  
  <h4 class="logout-title">{{ 'auth.messages.confirmLogout' | translate }}</h4>
  
  <div class="logout-actions">
    <button mat-stroked-button color="secondary" (click)="onCancel()" class="cancel-btn">
      {{ 'auth.buttons.cancelLogout' | translate }}
    </button>
    <button mat-raised-button color="primary" class="full-width" (click)="onConfirm()">
      {{ 'auth.buttons.confirmLogout' | translate }}
    </button>
  </div>
</div>
